import { render, staticRenderFns } from "./ChamadoDetalhe.vue?vue&type=template&id=0ed5a20f&"
import script from "./ChamadoDetalhe.vue?vue&type=script&lang=js&"
export * from "./ChamadoDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports